import { api } from '@utils/api/api'
import { CurrenciesExchanges } from '@interfaces'

export const getCurrenciesExchanges = (
  target: string,
): Promise<CurrenciesExchanges> => {
  return api.get(`/api/v1/mobile/currencies-exchanges?target=${target}`)
}
